import { ClientInfo, ClientContactList } from '@components/client'
import { UserQueue } from '@components/user'
import { useUserStore } from '@caradasstore/UserStore'
import { useHistory, useParams } from 'react-router-dom'
import { ChevronLeft } from 'lucide-react'
import { AdasBox, AdasPaper, AdasTabs } from '@components/wrapper-components'
import { PARAM_NAMES } from '../../constants'
import { isTech } from '../../utils/utils'
import { useState } from 'react'

export const ClientDetailsPage = () => {
  const [settingType, setSettingType] = useState('client')
  const { [PARAM_NAMES.CLIENT_ID]: clientId } = useParams()
  const history = useHistory()
  const currentUser = useUserStore((store) => store.currentUser)
  // Managing users is for managers, owners and admins, as in Settings → Team & roles.
  const canManageUsers = !!currentUser && !isTech(currentUser)
  const onTabChange = (e, value) => {
    setSettingType(value)
  }
  const tabs = [
    { label: 'CLIENT INFO', value: 'client' },
    { label: 'CONTACTS', value: 'contacts' },
    ...(canManageUsers ? [{ label: 'CLIENT USERS', value: 'users' }] : [])
  ]
  return (
    // Same width as the client list, so the page does not jump narrower on opening a client.
    <div className='mx-auto max-w-[1400px] px-3 min-[435px]:px-0'>
      <AdasBox className='hidden min-[435px]:flex pt-6 md:pt-4 mb-6 flex-wrap items-center justify-between gap-3'>
        <h1 className='text-[32px] font-bold leading-tight tracking-tight text-foreground'>Clients</h1>
      </AdasBox>
      <AdasBox className='mt-2 min-[435px]:mt-5'>
        <button
          type='button'
          onClick={() => history.push('/clients')}
          className='inline-flex items-center gap-1 text-[13px] font-medium text-[#1F6FEB] hover:underline'
        >
          <ChevronLeft className='h-4 w-4' />
          All Clients
        </button>
      </AdasBox>
      <AdasPaper className='mb-10 mt-2 bg-white px-4 py-4 shadow-none min-[435px]:mt-3 min-[435px]:px-5 min-[435px]:py-5 min-[435px]:shadow'>
        <AdasBox>
          <AdasTabs tabs={tabs} value={settingType} onChange={onTabChange} variant='scrollable' scrollButtons='auto' />
          {settingType === 'client' && <ClientInfo clientId={clientId} />}
          {settingType === 'contacts' && <ClientContactList clientId={clientId} />}
          {settingType === 'users' && canManageUsers && (
            <AdasBox className='mt-4'>
              <UserQueue clientId={clientId} />
            </AdasBox>
          )}
        </AdasBox>
      </AdasPaper>
    </div>
  )
}
